import styled from 'styled-components';

export default styled.div`
  padding-top: 8px;
  padding-bottom: 75px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%; 
`;
